import { useMemo } from 'react';
import { useTable } from 'react-table';
import { useIdCard } from '../../screens/HomeScreen/context/idCard';
import { Wrapper, TableTitle, TableWrapper } from './styles';

const tableHeaders = [
  {
    Header: 'Tag #',
    columns: [
      {
        Header: 'Tag # 2',
        displayNone: true,
        columns: [{ Header: 'Tag # 3', accessor: 'tagNr', displayNone: true }],
      },
    ],
    rowSpan: '3',
  },
  {
    Header: 'Product Description',
    columns: [
      {
        Header: 'Product Description INVISIBLE',
        displayNone: true,
        columns: [
          {
            Header: 'Product Description INVISIBLE',
            accessor: 'description',
            displayNone: true,
          },
        ],
      },
    ],
    rowSpan: '3',
  },
  {
    Header: 'Comment',
    columns: [
      {
        Header: 'Comment INVISIBLE',
        displayNone: true,
        columns: [
          {
            Header: 'Comment INVISIBLE',
            accessor: 'comment',
            displayNone: true,
          },
        ],
      },
    ],
    rowSpan: '3',
  },
];

const EquipmentList = ({ printMode, equipmentList: tableData, equipmentListComment }) => {
  const columns = useMemo(() => tableHeaders, []);
  const Table = ({ columns, data }) => {
    const tableInstance = useTable({ columns, data });

    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance;

    return (
      <table {...getTableProps()}>
        <colgroup>
          <col />
          <col />
          <col />
        </colgroup>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  rowSpan={`${column.rowSpan ?? 1}`}
                  style={column.displayNone ? { display: 'none' } : {}}>
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  return (
    <Wrapper>
      <TableTitle>{equipmentListComment ?? ''}</TableTitle>
      <TableWrapper printMode={printMode}>
        <Table
          columns={columns}
          data={tableData}
        />
      </TableWrapper>
    </Wrapper>
  );
};

export default EquipmentList;
